import * as Router from 'react-router-dom';
import * as React from 'react';
import { ScreenName } from 'lib/types';
import Header from '../Header';
import { Navigation } from '../Nav';
import navTree from '../data/nav-tree';
import clickFlows from '../data/click-flows';
import Guide from '../Guide';
import Body from '../Body';
import { Grid, Col } from 'lib/grid';
import { ScreenFlow } from 'lib/types';
import { BrandContext } from 'lib/withBrand';
import NavContext from 'lib/NavContext';

import './app.css';

interface AppProps {
	history: Router.BrowserHistory; 
	location: Router.BrowserLocation;
	match: Router.RouteMatch;
	screenFlow: ScreenFlow;
}

interface AppState {
  	nav: ScreenName;
}

const hashToScreenName = (hash: string) => hash.replace('#', '') as ScreenName;

export default class App extends React.Component<AppProps, AppState> {
	flowName: string;
	screenFlow: ScreenFlow;

	constructor (props: AppProps) {
		super(props);

		this.screenFlow = this.getScreenFlow(props);
		const navHasBeenSet = props.location && props.location.hash;
		const navStartName = this.screenFlow.start;

		if (navHasBeenSet) {
			this.state = { nav: hashToScreenName(props.location.hash) };
		} else {
			this.props.history.replace({ hash: navStartName });
			this.state = { nav: navStartName };
		}

		// History changes (defined here, after history.push above to prevent setState on an unmounted component)
		props.history.listen((location) => {
			this.setState({ nav: hashToScreenName(location.hash) });
		});
	}

	componentWillMount () {
		document.title = 'Salesforce Customer 360';
	}

	getScreenFlow (props: AppProps) {
		if (props.match.isExact) {
			let flowName = props.match.params.flow;
			if (!flowName) { // Attempt to find the flow by path instead
				flowName = props.match.path.replace('/', '');
			}
			this.flowName = flowName;
			const allNames = Object.keys(clickFlows);
			const flow = clickFlows[flowName];
			if (!flow) { 
				throw new Error(`Demo flow named "${flowName}" not found in "${allNames.join(', ')}"!`);
			}
			return flow;
		} else {
			return clickFlows.df18;
		}
	}

	goHome = () => {
		const { start } = this.screenFlow;
		this.props.history.push({ hash: start });
		window.location.reload(true);
	}

	goToAScreen = (nav: ScreenName) => {
		if (this.screenFlow.map[nav]) {
			this.props.history.push({ hash: nav });
		}
	}

	goToNextScreen = () => {
		const nextScreen = this.screenFlow.map[this.state.nav];
		this.goToAScreen(nextScreen as ScreenName);
	}

	render () {
		const navRedirector = this.screenFlow.navRedirector;
		const { nav } = this.state;
		const screenBrand = this.screenFlow.brand[nav];
		const navFunctions = {
			goToAScreen: this.goToAScreen,
			goToNextScreen: this.goToNextScreen
		};

		return (
			<BrandContext.Provider value={screenBrand}>
				<NavContext.Provider value={navFunctions}>
					<Header className={this.flowName} onClick={this.goHome} />
					<Grid className={`app-container ${this.flowName}`}>
						<Col className="nav" size="1-of-5">
							<Navigation onClick={this.goToAScreen} nav={nav} nodes={navTree} navRedirector={navRedirector} />
						</Col>
						<Col>
							<Grid className="app-body" vertical>
								<Col size="1-of-1">
									<Guide onClick={this.goToNextScreen} nav={nav} />
								</Col>
								<Col>
									<Body onClick={this.goToNextScreen} nav={nav} />
								</Col>
							</Grid>
						</Col>
					</Grid>
				</NavContext.Provider>
			</BrandContext.Provider>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/index.tsx